<template>
  <div style="display: inline-block">
      <div class="mt-2 mb-2 mx-1 subtitle-2 d-flex justify-center" style="white-space: nowrap;">
        {{ description }}
      </div>

      <!-- <v-divider></v-divider> -->
      
      <div class="d-flex justify-center mb-2">
        <v-chip small :color="`${colorSecondaryChip} white--text`" class="mt-2">{{ value }}</v-chip>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Chip',
  props: ['description', 'value', 'colorSecondaryChip', 'open'],
}
</script>
